import axios from "axios";
import Cookies from "js-cookie";
import { getDeviceFingerprint } from "../utils/util";
export const USER_LOGIN = "USER_LOGIN";
export const SIGNOUT_REQUEST = "SIGNOUT_REQUEST";
export const UNAUTHORIZED_REQUEST = "UNAUTHORIZED_REQUEST";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const SET_ATTENDANCE_DOCUMENT_NUMBER = "SET_ATTENDANCE_DOCUMENT_NUMBER";
export const RESEND_MFA_CODE = "RESEND_MFA_CODE";
export const LOGIN_WITH_MFA = "LOGIN_WITH_MFA";
export const USER_LOGIN_WITH_MFA = "USER_LOGIN_WITH_MFA";

const handleLoginResponse = (response, userName) => {
  const { token, roles, mfAexpirationTime } = response;
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  return {
    token,
    roles,
    userName,
    mfAexpirationTime,
  };
};

export const loginUserSuccessful = (data) => (dispatch) => {
  const { email, ...auth } = data;
  return dispatch({
    type: `${USER_LOGIN}_FULFILLED`,
    payload: handleLoginResponse(auth.auth, email),
  });
};

export const loginWithMFA = (MFACode, userName) => (dispatch) => {
  return dispatch({
    type: USER_LOGIN_WITH_MFA,
    payload: axios
      .post("account/loginMFA", { MFACode, userName, deviceFingerprint: getDeviceFingerprint() })
      .then((response) => {
        dispatch(loginUserSuccessful({ email: userName, auth: response.data }));
        return response.data;
      })
      .catch((error) => Promise.reject(error)),
  })
}

export const resendMfaCode = (credentials) => (dispatch) => {
  return dispatch({
    type: RESEND_MFA_CODE,
    payload: axios
      .post("account/resendMFA", { ...credentials, deviceFingerprint: getDeviceFingerprint() })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const loginUser = (credentials, userName) => (dispatch) => {
  return dispatch({
    type: USER_LOGIN,
    payload: axios
      .post("account/login", { ...credentials, deviceFingerprint: getDeviceFingerprint() })
      .then((response) => {
        return handleLoginResponse(response.data, userName);
      })
      .catch((error) => Promise.reject(error)),
  });
};


export const signoutUser = () => (dispatch) => {
  const cerrarSesionLocal = () => {
    Object.keys(Cookies.get()).forEach((cookie) => Cookies.remove(cookie));
    delete axios.defaults.headers.common["Authorization"];
    dispatch({
      type: SIGNOUT_REQUEST,
      payload: {},
    });
  };

  return axios.post("account/logout").then(cerrarSesionLocal).catch(cerrarSesionLocal);
};

export const impersonateUser = (user) => ({
  type: USER_LOGIN,
  payload: axios
    .post("account/impersonate", user)
    .then((response) => {
      const { token } = response.data;
      const { roles } = response.data;
      axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
      return {
        token,
        roles,
        userName: user.email,
      };
    })
    .catch((error) => Promise.reject(error)),
});

export const refreshToken = (data) => {
  axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
  return {
    type: REFRESH_TOKEN,
    payload: data.token,
  };
};


export const setAttendanceDocumentNumber = (documentNumber) => (dispatch) => {
  return dispatch({
    type: SET_ATTENDANCE_DOCUMENT_NUMBER,
    payload: documentNumber,
  })
}